import { IDerivedMintInfo } from 'src/state/mintStore';
import { Currency, Field } from '@cryptoalgebra/kim-sdk';
import { useEffect } from 'react';
import { VStack, Text } from '@chakra-ui/react';
import EnterAmountCard from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmountsCard';
import {
  useLiquidityWizardState,
  useMintActionHandlers
} from '@app/screens/liquidity/LiquidityWizard/state';

interface EnterAmountsProps {
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
  mintInfo: IDerivedMintInfo;
}

const EnterAmounts = ({
  currencyA,
  currencyB,
  mintInfo
}: EnterAmountsProps) => {
  const { independentField, typedValue } = useLiquidityWizardState();

  const { onFieldAInput, onFieldBInput } = useMintActionHandlers(
    mintInfo.noLiquidity
  );

  const formattedAmounts = {
    [independentField]: typedValue,
    [mintInfo.dependentField]:
      mintInfo.parsedAmounts[mintInfo.dependentField]?.toSignificant(6) ?? ''
  };

  useEffect(() => {
    return () => {
      onFieldAInput('');
      onFieldBInput('');
    };
  }, [onFieldAInput, onFieldBInput]);

  return (
    <>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyA}
          value={formattedAmounts[Field.CURRENCY_A]}
          handleChange={value => onFieldAInput(value)}
          isDisabled={mintInfo.depositADisabled}
        />
        {mintInfo.depositADisabled && (
          <Text fontSize="12px" color="neutral.400">
            For selected range this deposit is disabled
          </Text>
        )}
      </VStack>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyB}
          value={formattedAmounts[Field.CURRENCY_B]}
          handleChange={value => onFieldBInput(value)}
          isDisabled={mintInfo.depositBDisabled}
        />
        {mintInfo.depositBDisabled && (
          <Text fontSize="12px" color="neutral.400">
            For selected range this deposit is disabled
          </Text>
        )}
      </VStack>
    </>
  );
};

export default EnterAmounts;
